import { NumericFormat } from "react-number-format";
import {
  formatCurrency,
  formatPercentWithSignAndPercentage,
} from "../utils/numberFormatters";
interface CalculatedCurrencyCellProps {
  name: string;
  value: number;
  currencySymbol?: string;
  percentSymbol?: string;
  textColor?: string;
  invertColors?: boolean;
  isDiff?: boolean;
}

interface CustomInputProps extends CalculatedCurrencyCellProps {
  textColor?: string;
  isDiff?: boolean;
}
const CustomInput = ({
  value,
  name,
  invertColors,
  textColor,
  isDiff = false,
}: CustomInputProps) => {
  let displayValue = formatCurrency(value);
  if (!!isDiff && value > 0) displayValue = `+${displayValue}`;

  const getTextColor = (value: number) => {
    if (textColor) return textColor;
    if (!isDiff) return "text-black";

    if (value === 0) return "text-gray-500";
    if (!!invertColors) {
      return value < 0 ? "text-green-600" : "text-red-600";
    }
    return value < 0 ? "text-red-600" : "text-green-600";
  };

  return (
    <div className="relative flex items-center gap-0 rounded-md group">
      <input
        disabled
        readOnly
        name={name}
        value={displayValue}
        className={`block w-full py-1 bg-transparent outline-none group-focus-within:bg-gray-100 rounded-r-md ${getTextColor(
          value
        )} text-right`}
      />
    </div>
  );
};

const CalculatedCurrencyCell = ({
  name,
  value,
  textColor,
  invertColors,
  isDiff,
}: CalculatedCurrencyCellProps) => (
  <>
    {isDiff ? (
      <CustomInput
        value={value}
        name={name}
        textColor={textColor}
        invertColors={invertColors}
        isDiff={isDiff}
      />
    ) : (
      <NumericFormat
        value={value}
        customInput={CustomInput}
        valueIsNumericString={true}
        thousandSeparator={true}
        decimalScale={2}
        allowLeadingZeros={false}
        allowNegative={false}
        readOnly={true}
        name={name}
        textColor={textColor}
      />
    )}
  </>
);

export default CalculatedCurrencyCell;
